import { ChevronLeft } from "@styled-icons/feather/ChevronLeft"

import styles from "./styles.module.scss"

type BreadCrumbProps = {
  text: string
  onClick: () => void
}

const BreadCrumb = ({ text, onClick }: BreadCrumbProps) => {
  return (
    <div className={styles.breadCrumb}>
      <div
        onClick={onClick}
        onKeyDown={(e) => e.key === "Enter" && onClick()}
        className={styles.breadCrumb_button}
        role="button"
        tabIndex={0}
        aria-label={`Go back to ${text}`}>
        <ChevronLeft size={24} />
        <span>{text}</span>
      </div>
    </div>
  )
}

export default BreadCrumb
